import { render, staticRenderFns } from "./DfLabel.vue?vue&type=template&id=7cd972d4&scoped=true&"
import script from "./DfLabel.vue?vue&type=script&lang=js&"
export * from "./DfLabel.vue?vue&type=script&lang=js&"
import style0 from "./DfLabel.vue?vue&type=style&index=0&id=7cd972d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd972d4",
  null
  
)

export default component.exports